import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { ToastService } from '@shared/services/toast.service';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, defaultIfEmpty, map } from 'rxjs/operators';
import { AirportBriefingPdfOutcome, AirportBriefingPdfPort } from './airport-briefing-pdf';

@Injectable()
export class AirportApiService implements AirportBriefingPdfPort {
  private http = inject(HttpClient);
  private message = inject(ToastService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
  }

  getAirportPdf(id: number, handler?: number): Observable<AirportBriefingPdfOutcome> {
    return this.http.get(`${environment.API_ROOT}airport/pdf/${id}${handler ? `?handlerInfoId=${handler}` : ''}`, {responseType: 'blob'})
      .pipe(
        map(pdf => ({ ok: true as const, pdf })),
        catchError((error) => {
          if (error.status === 403) {
            this.message.error('Access denied. You do not have permission to download this PDF.');
          } else {
            this.message.error('An error occurred while downloading the PDF.');
          }
          return of({ ok: false as const });
        }),
        defaultIfEmpty({ ok: false as const }),
      );
  }

  addHandlers(id: number) {
    return this.http.post(`${environment.API_ROOT}users/handlers/${id}/add/`, {})
      .pipe(
        map((res: any) => res),
        catchError((error) => {
          if (error.status === 403) {
            this.message.error('Access denied. You do not have permission to add handlers.');
          } else {
            this.message.error('An error occurred while adding handlers.');
          }
          return EMPTY;
        })
      );
  }
}
